export default __webpack_public_path__ + "static/media/heavenWarehouseLogo.c6e9ba0d.png";